import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { EndpointService } from '@app/endpoint/endpoint.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '@app/user/user.service';
import { SharedUtilService } from '@app/_shared/shared-util.service';
import { constants } from '@assets/data/constants';

@Component({
  selector: 'app-playwright-autoselect-locator-modal',
  templateUrl: './playwright-autoselect-locator-modal.component.html',
  styleUrls: ['./playwright-autoselect-locator-modal.component.less']
})
export class PlaywrightAutoselectLocatorModalComponent implements OnInit {

  @Input() uiMeta: any;
  @Input() fieldName: any;
  @Input() webInstruction: any;
  @Input() webLocatorsList: any = [];
  @Input() userProjects: any;
  @Input() editAutoSelectedLoc: any;
  @Input() endPointDetails: any;
  @Input() baseLocator: boolean;
  @Output() modalClosed: EventEmitter<any> = new EventEmitter();
  @Output() selectedLocator: EventEmitter<any> = new EventEmitter();

  constants = constants;
  createForm: FormGroup;
  isNewPageLabel = false;
  pageLabelList: any = [];
  newPageLabelName: string;
  ariaRoleItems: string[] = ['ALERT','ALERTDIALOG','APPLICATION','ARTICLE','BANNER','BLOCKQUOTE','BUTTON','CAPTION','CELL','CHECKBOX','CODE','COLUMNHEADER','COMBOBOX','COMPLEMENTARY','CONTENTINFO','DEFINITION','DELETION','DIALOG','DIRECTORY','DOCUMENT','EMPHASIS','FEED','FIGURE','FORM','GENERIC','GRID','GRIDCELL','GROUP','HEADING','IMG','INSERTION',
    'LINK','LIST','LISTBOX','LISTITEM','LOG','MAIN','MARQUEE','MATH','METER','MENU','MENUBAR','MENUITEM','MENUITEMCHECKBOX','MENUITEMRADIO','NAVIGATION','NONE','NOTE','OPTION','PARAGRAPH','PRESENTATION','PROGRESSBAR','RADIO','RADIOGROUP','REGION','ROW','ROWGROUP','ROWHEADER','SCROLLBAR','SEARCH','SEARCHBOX','SEPARATOR',
    'SLIDER','SPINBUTTON','STATUS','STRONG','SUBSCRIPT','SUPERSCRIPT','SWITCH','TAB','TABLE','TABLIST','TABPANEL','TERM','TEXTBOX','TIME','TIMER','TOOLBAR','TOOLTIP','TREE','TREEGRID','TREEITEM'];

  constructor(private activeModal: NgbActiveModal, private formBuilder: FormBuilder, private endPointService: EndpointService,
    private toastr: ToastrService, private userService: UserService, private sharedUtilService: SharedUtilService) { }

  ngOnInit() {
    this.setCreateForm();
    this.getPageLabelList();
    this.getPlaywrightLocatorType();
    this.getPlaywrightComponentType();
    this.editLocator();
  }

  pageLabelRequiredValidator(pageLabelControl: AbstractControl): Validators {
    this.isNewPageLabel = !this.isNewPageLabel;
    if (!pageLabelControl.parent) {
      return;
    }
    if (!this.isNewPageLabel) {
      pageLabelControl.setValidators(Validators.required);
    } else {
      pageLabelControl.clearValidators();
      pageLabelControl.updateValueAndValidity();
    }
  }

  setCreateForm(): void {
    this.createForm = this.formBuilder.group({
      id: [''],
      name: [null, Validators.required],
      locatorType: [null, Validators.required],
      componentType: [null, Validators.required],
      locatorString: ['', Validators.required],
      pageLabel: [null, Validators.required],
      ariaRole: [null],
      sequence:(0)
    });

    // Add listener for locatorType changes to handle ariaRole validation
    this.createForm.get('locatorType').valueChanges.subscribe(value => {
      const ariaRoleControl = this.createForm.get('ariaRole');
      if (value === 'BY_ROLE') {
        ariaRoleControl.setValidators(Validators.required);
      } else {
        ariaRoleControl.clearValidators();
        ariaRoleControl.setValue(null);
      }
      ariaRoleControl.updateValueAndValidity();
    });
  }
  getPlaywrightLocatorType(){
    this.endPointService.getPwWebLocatortype().subscribe(data => {
      if (data.code === 200) {
        this.uiMeta.locatorTypes = data.response;
      }
    });
  }
  getPlaywrightComponentType(){
    this.endPointService.getPwComponentType().subscribe(data => {
      if (data.code === 200) {
        this.uiMeta.componentTypes = data.response;
      }
    });
  }

  getPageLabelList() {
    this.userService.getAllPwPageLabels().subscribe(data => {
      if (data.code === 200) {
        this.pageLabelList = data.response;
        if (!this.createForm.value.id) {
          this.createNewLocator();
        }
      } else {
        this.pageLabelList = [];
        this.createNewLocator();
      }
    });
  }


  editLocator() {
    this.isNewPageLabel = false;
    this.newPageLabelName = '';
    this.createForm.patchValue({
      id: this.editAutoSelectedLoc?.id ? this.editAutoSelectedLoc?.id : this.editAutoSelectedLoc?.sqlId,
      name: this.editAutoSelectedLoc?.name,
      locatorType: this.editAutoSelectedLoc?.locatorType,
      componentType: this.editAutoSelectedLoc?.componentType,
      locatorString: this.editAutoSelectedLoc?.locatorString,
      pageLabel: this.editAutoSelectedLoc?.pageLabel,
      ariaRole: this.editAutoSelectedLoc?.ariaRole,
      sequence:this.editAutoSelectedLoc?.sequence ? this.editAutoSelectedLoc.sequence : 0
    });
  }

  saveLocator() {
    let webLocator = Object.assign({}, this.createForm.value);
    webLocator.project = this.endPointDetails.project;
    webLocator.sequence = 0;
    webLocator.id = webLocator.id || '';

    if (webLocator.locatorType !== 'BY_ROLE') {
      delete webLocator.ariaRole;
    }

    if (this.isNewPageLabel) {
      webLocator.pageLabel = {
        id: null,
        name: this.newPageLabelName
      };
    }

    const onSuccess = (data: any) => {
      if (data.code === 200) {
        this.toastr.success(data.message);

        const updateLocator = (responsePageLabel = webLocator.pageLabel) => {
          webLocator = {
            ...webLocator,
            pageLabel: responsePageLabel,
            project: null,
            createdBy: null,
            active: false,
            baseLocator: false,
            createdOn: null,
            updatedBy: null,
            updatedOn: null,
            id: data.response.id,
          };
          this.selectLocatorToField(webLocator);
          this.close();
          this.createForm.reset();
        };

        if (this.isNewPageLabel) {
          this.userService.getAllPwPageLabels().subscribe(pageLabels => {
            if (pageLabels.code === 200) {
              const selectedPageLabel = pageLabels.response.find(pageLabel => pageLabel.name === webLocator.pageLabel.name);
              updateLocator(selectedPageLabel || webLocator.pageLabel);
            } else {
              this.pageLabelList = [];
            }
          });
        } else {
          updateLocator();
        }
      } else {
        this.toastr.error(data.message);
      }
    };

    if (webLocator.id) {
      this.userService.updatePlaywrightWebLocator(webLocator).subscribe(onSuccess);
    } else {
      this.userService.addPlaywrightWebLocator(webLocator).subscribe(onSuccess);
    }
  }

  cancelCreateForm() {
    this.createForm.reset();
  }


  selectLocatorToField(webLocator) {
    this.selectedLocator.emit(webLocator);
  }

  createNewLocator() {
    this.isNewPageLabel = false;
    this.newPageLabelName = '';
    const isUnlabelled = this.pageLabelList.some(label => label.name === constants.pageUnlabelled);
    if(this.pageLabelList.length > 0 && isUnlabelled) {
      this.createForm.controls.pageLabel.setValue(this.pageLabelList.filter(label => label.name === constants.pageUnlabelled)[0]);
    }else{
      this.createForm.controls.pageLabel.setValue({
        id: 1,
        active: true,
        createdBy: null,
        createdOn: null,
        updatedBy: null,
        updatedOn: null,
        name: constants.pageUnlabelled,
        pwWebLocatorIds: null
      });
    }
    
    // Set default component type
    if (this.uiMeta && this.uiMeta.componentTypes && this.uiMeta.componentTypes.length > 0) {
      this.createForm.controls.componentType.setValue(this.uiMeta.componentTypes[13]);
    }
  }

  close() {
    this.activeModal.dismiss();
    // this.modalClosed.emit();
  }

  // GETTERs
  get pageLabelControl() {
    return this.createForm.controls.pageLabel;
  }
}
